import styled from 'styled-components';
import { Modal, Form, Alert, Button } from 'antd';
import { FormItem } from '@xbcb/form-item-components';

// is there a standard way we are doing so right now?
// Also the question mark icon from antd is black. is there a stanrdard way to change the color other than hard coding color?
export const StyledModal = styled(Modal)`
  padding: 48px;
  font-size: 16px;
  label {
    font-size: 18px;
  }

  .ant-modal-body {
    display: flex;
    flex-direction: column;
  }
  h4 {
    margin-left: 10px;
    margin-bottom: 0px;
    padding-right: 4px;
  }
`;

export const StyledForm = styled(Form)`
  display: inline;
`;

export const StyledFormInlineDiv = styled.div`
  display: flex;
  align-items: center;
  .ant-form-item {
    margin-bottom: 0px;
  }
  .ant-form-item-control-input {
    min-height: 22px;
  }
`;

export const StyledIorCard = styled.div`
  .ant-form-item {
    margin-bottom: 0px;
  }
  flex-direction: row;
  display: flex;
  margin-bottom: 16px;
`;

export const StyledIorWarningCard = styled.div`
  flex-direction: row;

  a {
    text-decoration: underline;
  }
`;

export const StyledAnchor = styled.a`
  text-decoration: underline;
`;

export const StyledAlert = styled(Alert)`
  width: calc(var(--short) - var(--space-4));
  margin-top: 8px;
  margin-left: 8px;
  ul {
    padding-left: 12px;
  }
`;

export const StyledBillCard = styled.div`
  margin-bottom: 16px;
  flex-direction: row;
  display: flex;
  .ant-form-item {
    width: calc(var(--short) - var(--space-4));
    margin-bottom: 0;
  }
  .ant-form-item-control {
    height: 32px;
  }
`;

export const StyledMotCard = styled.div`
  flex-direction: row;
  display: flex;
  .ant-form-item {
    width: calc(var(--short) - var(--space-4));
  }
`;

export const StyledClientIdCard = styled.div`
  margin-bottom: 16px;
  flex-direction: row;
  display: flex;
`;

export const StyledClientId = styled.div`
  flex-flow: row wrap;
  display: flex;
  .ant-form-item {
    width: calc(var(--short) - var(--space-4));
    margin-bottom: 0;
  }
  a {
    text-decoration: underline;
  }
`;

export const StyledPartyCard = styled.div`
  flex-direction: row;
  display: flex;
`;

export const StyledManualCreationFeeCard = styled(FormItem)`
  label {
    font-size: medium;
  }
`;
export const StyledBookingIdCheckbox = styled.div`
  font-size: 12px;
  .ant-checkbox-wrapper {
    font-size: 12px;
  }
`;

export const StyledManualCreationFeePrompt = styled.div`
  margin-left: 20px;
`;

export const StyledProject42Modal = styled(Modal)`
  padding: 48px;
  font-size: 14px;

  label {
    font-size: 14px;
  }

  .ant-modal-body {
    display: flex;
    flex-direction: column;
  }
`;

export const Project42ModalHeader = styled.div`
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 12px;
  margin-bottom: 24px;
  border-bottom: 1px solid #f0f0f0;
`;

export const Project42FormSectionHeader = styled.h4`
  font-size: inherit;
  font-weight: normal;
  margin: 0 0 4px 0;
  padding: 0;
`;

export const StyledProject42UploadDragContainer = styled.div`
  height: 100px;
  margin: 0 ${({ theme }) => theme.spacing.space_4};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  > p {
    margin-top: 8px;
    font-size: 16px;
    color: black;
  }

  > span {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    margin-top: 2px;
  }
`;

export const StyledProject42UploadIconButton = styled(Button)`
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  background: none !important;
  box-shadow: none;
  opacity: 1;

  &:hover,
  &:focus,
  .anticon {
    font-size: 36px;
    color: #780650;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const StyledProject42IorCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 0px;
  font-size: 14px;

  > div {
    width: 100%;
  }

  .ant-form-item {
    width: 100%;
    margin-bottom: 0;
  }

  input {
    background: white;
    color: black;
    font-size: 14px;
  }
`;

export const StyledProject42IorWarningCard = styled.div`
  margin-left: -10px;

  .ant-alert {
    width: 100%;

    .ant-alert-message {
      white-space: normal;
      word-break: break-word;
    }

    a {
      color: #780650;
      text-decoration: underline;
    }
  }
`;

interface StyledProject42CardProps {
  direction?: 'row' | 'column';
}

export const StyledProject42Card = styled.div<StyledProject42CardProps>`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
  margin-bottom: 16px;
  font-size: 14px;
  gap: 12px;

  > div {
    width: var(--short);
  }

  .ant-form-item {
    width: 100% !important;
    margin-bottom: 0 !important;
  }

  /* Override grey background and font size from internal StyledFormItem */
  .ant-input,
  .ant-input-affix-wrapper,
  .ant-picker,
  .ant-picker input,
  .ant-select-selector,
  .ant-select-selection-item,
  textarea {
    background-color: white !important;
    color: black !important;
    font-size: 14px !important;
  }

  .ant-select-multiple .ant-select-selection-item {
    background: white !important;
  }

  .ant-picker-clear {
    background: transparent !important;
  }

  .ant-select-selection-placeholder {
    color: rgba(0, 0, 0, 0.25) !important;
  }
`;

export const StyledFilingTypesCard = styled(Form.Item)`
  font-size: 14px;
  margin-bottom: 4px;

  .ant-form-item {
    margin-bottom: 4px;
  }

  .ant-checkbox-wrapper {
    font-size: inherit;
    margin-right: 16px;
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }

  .ant-checkbox-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }
`;

export const StyledFilingInfoBox = styled.div`
  width: 524px;
  height: 40px;
  padding: 9px 16px;
  opacity: 1;
  border-radius: 2px;
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 15px;
`;
